import React, { useMemo } from 'react';
import { MdReceipt } from 'react-icons/md';
import { useTitleOpinion, useForm } from '~/hooks';
import { useLoadSection } from '~/hooks/useSection';
import sectionTypes from '../sectionTypes';
import DeedsOfTrust from './DeedsOfTrust';

const DeedSection = () => {
    const { titleOpinionId, readonly, hasFileNumber } = useTitleOpinion();

    const { onLoad } = useLoadSection(sectionTypes.DEED, titleOpinionId);

    const {
        state
    } = useForm({
        initialState: {
            sectionId: 0,
            sectionDetails: []
        },
        onLoad
    });

    const _readonly = useMemo(() => readonly || !hasFileNumber, [readonly, hasFileNumber]);

    return (
        <div className="mx-5">
            <div className="mb-5">
                <div>
                    <div className="z-10 flex items-center h-full text-xl font-semibold text-blue-60">
                        <div className="h-11 w-11 rounded-md flex items-center justify-center bg-blue-30"><MdReceipt size="45%"/></div>
                        <h2 className="ml-2"> Deed of Trust </h2>
                    </div> 
                </div>
            </div>
            <span className="block text-sm text-neutral-90 mb-2">Please note any information changes will overwrite any previously entered. Changes are saved automatically.</span>
            <DeedsOfTrust titleOpinionId={titleOpinionId} readonly={_readonly} {...state.values}/>
        </div>
    );
};

export default DeedSection;

export { default as Review } from './Review';